import React from 'react'

export const OraculoSvg = () => {
    return (
<svg viewBox="0 0 1024.000000 1024.000000" width="1.5em" height="1.5em" fill="currentColor" stroke='4'  >
<g transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)" stroke='4' >
<path stroke='4'  d="M4705 9744 c-906 -24 -1770 -193 -2165 -424 -104 -61 -203 -158 -242
-239 -30 -59 -33 -74 -33 -156 0 -82 3 -97 33 -158 108 -218 403 -373 944
-494 92 -21 168 -40 167 -43 0 -3 -39 -31 -87 -62 -344 -224 -643 -572 -825
-957 -27 -57 -71 -170 -97 -250 -91 -273 -134 -484 -147 -713 -3 -65 -8 -118
-11 -118 -3 0 -51 44 -106 98 -94 91 -289 251 -466 383 -171 127 -442 299
-758 481 -257 148 -270 153 -331 120 -42 -22 -71 -74 -71 -123 0 -38 68 -273
210 -723 286 -909 446 -1312 641 -1611 195 -300 462 -539 721 -646 142 -59
248 -81 419 -86 l156 -6 67 -132 c232 -461 598 -850 1059 -1129 l99 -60 -6
-110 c-4 -61 -9 -131 -12 -156 l-5 -46 -207 -77 c-222 -83 -687 -251 -894
-323 -222 -78 -363 -152 -512 -268 -254 -199 -434 -487 -527 -845 -55 -211
-50 -300 20 -350 l29 -21 3349 0 c3303 0 3348 0 3380 20 68 41 79 108 43 273
-67 307 -207 586 -392 783 -198 208 -428 346 -748 446 -88 28 -746 264 -816
293 -30 12 -31 13 -43 126 -7 63 -23 170 -36 239 -14 69 -25 126 -25 127 0 1
30 23 68 49 207 147 455 375 595 549 111 138 225 314 308 478 l70 137 113 0
c448 0 847 242 1155 701 244 363 407 793 765 2028 53 180 86 312 86 340 0 94
-73 155 -155 131 -75 -23 -631 -353 -851 -505 -103 -72 -387 -291 -484 -373
-36 -31 -102 -91 -146 -135 l-82 -80 -6 99 c-29 459 -168 905 -386 1239 -182
278 -410 508 -697 703 l-103 69 113 22 c227 45 444 114 602 194 279 139 426
333 395 519 -32 195 -200 340 -557 482 -233 93 -736 199 -1165 245 -293 32
-1022 55 -1413 45z m950 -285 c457 -23 848 -78 1245 -174 169 -41 437 -138
526 -190 108 -63 166 -142 145 -197 -45 -118 -306 -253 -660 -343 -92 -23
-322 -68 -501 -99 l-85 -14 -115 39 c-247 83 -539 145 -800 169 -147 13 -510
13 -665 -1 -275 -23 -555 -81 -789 -163 -120 -42 -123 -42 -202 -33 -111 12
-360 61 -550 108 -310 75 -515 162 -614 258 -64 63 -77 98 -53 149 34 72 155
145 370 221 417 149 950 239 1598 271 121 6 249 12 285 14 104 6 658 -4 865
-15z m-260 -1084 c202 -21 302 -39 482 -85 354 -92 664 -237 930 -436 97 -73
275 -244 358 -344 345 -416 513 -951 491 -1570 -15 -448 -112 -1043 -233
-1430 -148 -475 -334 -790 -663 -1121 -130 -131 -360 -330 -380 -328 -3 0 -21
21 -41 47 -20 27 -58 60 -90 77 -47 26 -64 30 -134 30 -66 0 -90 -5 -137 -27
-105 -49 -188 -150 -204 -246 -4 -23 -8 -42 -9 -42 -2 0 -97 58 -212 129 -237
146 -327 194 -396 212 -64 16 -179 6 -240 -20 -134 -58 -336 -237 -494 -439
l-19 -24 -92 36 c-193 74 -435 210 -612 343 -406 306 -677 667 -868 1155 -126
321 -182 558 -276 1153 -46 290 -58 652 -30 893 34 303 94 511 224 777 217
443 542 764 1005 990 197 96 433 177 635 219 85 17 343 54 410 58 158 11 461
7 595 -7z m-4472 -1606 c23 -12 107 -62 186 -111 410 -255 700 -477 926 -709
153 -158 235 -267 235 -314 0 -45 34 -268 60 -394 26 -123 25 -130 -8 -46 -89
223 -423 623 -742 889 -137 114 -186 146 -224 146 -61 0 -96 -52 -75 -108 5
-13 87 -106 183 -207 352 -372 505 -586 546 -763 37 -159 112 -285 231 -388
50 -43 159 -104 186 -104 6 0 19 -26 28 -57 9 -32 34 -112 55 -179 22 -66 40
-124 40 -129 0 -14 -161 3 -245 25 -333 88 -657 404 -875 855 -32 66 -84 183
-115 260 -90 223 -314 897 -411 1235 -15 52 -29 101 -31 108 -7 17 1 15 50 -9z
m8352 -26 c-256 -882 -404 -1313 -552 -1605 -260 -515 -620 -817 -1007 -845
l-89 -6 5 24 c3 13 28 95 55 182 l50 159 55 22 c184 75 327 257 378 480 16 73
33 114 70 176 104 173 262 370 495 617 115 122 145 160 151 190 11 61 -33 101
-98 89 -87 -16 -528 -430 -690 -646 -110 -148 -234 -342 -248 -389 -19 -62
-20 -64 -25 -59 -3 3 6 63 19 134 13 71 32 192 42 269 20 159 24 166 145 310
237 281 599 561 1174 908 81 49 87 48 70 -10z m-4155 -3776 c168 -90 488 -293
659 -419 178 -131 334 -301 414 -449 50 -91 100 -231 146 -410 64 -248 233
-800 277 -906 5 -10 -128 -13 -645 -13 l-650 0 -58 48 c-109 91 -207 216 -263
335 -27 57 -57 82 -170 139 -89 45 -112 70 -124 136 -6 33 -6 34 27 27 34 -8
123 -41 248 -95 92 -39 135 -36 184 13 60 60 53 147 -16 200 -42 31 -228 111
-306 131 -32 8 -82 18 -110 22 l-53 7 0 61 c1 89 44 175 89 176 8 0 115 -40
239 -90 239 -96 287 -106 342 -74 15 9 35 29 44 44 31 53 13 145 -34 170 -38
20 -264 112 -370 150 -95 34 -105 40 -108 64 -8 63 88 186 145 186 16 0 103
-45 217 -112 105 -62 211 -122 235 -135 162 -84 294 103 149 210 -50 37 -363
211 -458 256 -154 72 -192 67 -350 -48 -94 -68 -138 -78 -181 -42 l-24 20 24
45 c49 94 269 303 366 347 48 22 81 24 115 6z m1028 -49 c34 -56 80 -201 107
-338 36 -188 35 -194 -21 -123 -26 32 -79 92 -119 133 -86 89 -92 98 -100 177
-9 75 5 123 46 158 41 33 63 32 87 -7z m-1846 -413 c51 -20 69 -33 78 -55 25
-59 123 -132 215 -160 40 -12 40 -12 36 -56 -2 -37 -8 -47 -30 -59 -41 -21
-97 -87 -131 -155 -35 -69 -31 -69 -136 -18 -74 36 -165 114 -188 162 -17 36
-22 221 -10 344 l7 61 46 -19 c25 -10 76 -30 113 -45z m-392 -463 c41 -78 108
-152 185 -207 66 -48 201 -115 271 -135 l42 -12 6 -82 c4 -44 9 -100 12 -123
l6 -42 -73 20 c-214 58 -412 195 -552 384 -56 76 -113 173 -105 181 3 3 161
69 175 73 1 1 16 -25 33 -57z m2948 -118 c163 -58 381 -135 484 -170 284 -96
420 -172 571 -321 96 -94 163 -186 227 -313 47 -94 102 -243 115 -313 l7 -37
-675 0 -676 0 -31 83 c-117 302 -287 853 -315 1020 -8 50 -18 107 -21 125 -3
20 -1 32 6 32 6 0 145 -48 308 -106z m-3377 -59 c131 -250 341 -457 584 -578
99 -49 198 -83 369 -127 81 -21 155 -45 165 -53 9 -8 53 -36 99 -62 70 -40 86
-54 106 -94 13 -25 45 -74 70 -109 25 -34 46 -64 46 -67 0 -3 -661 -5 -1470
-5 -1247 0 -1470 2 -1470 14 0 31 54 196 90 279 80 179 201 334 353 448 97 73
278 163 452 223 72 25 227 81 345 125 118 43 218 76 222 72 4 -3 21 -33 39
-66z"/>
<path stroke='4'  d="M3516 6665 c-86 -18 -187 -51 -246 -80 -102 -51 -236 -168 -271 -237
-53 -104 13 -210 122 -195 31 4 53 17 97 59 149 141 320 197 562 185 179 -9
315 -57 433 -154 99 -81 118 -93 154 -93 43 0 84 21 117 60 104 124 -128 354
-441 437 -85 22 -123 26 -278 29 -128 2 -200 -1 -249 -11z"/>
<path stroke='4'  d="M6180 6661 c-279 -61 -510 -231 -510 -377 0 -21 9 -53 20 -71 50 -83
127 -85 219 -5 124 108 234 160 391 183 100 14 269 7 355 -16 88 -24 198 -82
263 -140 82 -74 102 -85 148 -85 90 0 148 96 113 187 -29 76 -169 197 -300
257 -134 61 -221 78 -429 82 -153 3 -200 1 -270 -15z"/>
<path stroke='4'  d="M3511 6010 c-294 -41 -533 -250 -606 -530 -24 -90 -25 -265 -2 -350
72 -273 288 -475 593 -557 90 -24 116 -27 279 -27 165 0 189 2 285 27 128 34
287 110 356 170 97 87 140 207 131 366 -23 413 -313 781 -692 880 -90 24 -253
34 -344 21z m-51 -312 c-46 -46 -79 -102 -113 -193 -26 -69 -31 -97 -35 -206
-3 -97 -1 -139 12 -185 23 -82 65 -182 97 -229 42 -62 144 -162 189 -185 22
-11 40 -22 40 -24 0 -2 -28 2 -62 10 -210 47 -388 222 -443 434 -13 48 -16 92
-13 167 4 96 7 108 46 187 50 101 118 167 223 220 88 44 100 45 59 4z m640
-167 c87 -63 94 -177 15 -251 -23 -21 -36 -25 -91 -25 -60 0 -66 2 -100 36
-78 79 -60 199 39 248 48 25 96 22 137 -8z"/>
<path stroke='4'  d="M6405 6009 c-199 -28 -418 -153 -542 -308 -207 -261 -290 -625 -190
-841 36 -77 129 -161 237 -213 165 -80 342 -113 545 -104 267 13 482 108 652
290 82 89 134 186 164 307 45 177 9 391 -89 541 -162 247 -459 373 -777 328z
m339 -301 c120 -47 201 -123 258 -244 32 -67 33 -72 33 -199 -1 -123 -2 -134
-33 -210 -72 -178 -221 -313 -399 -359 -77 -20 -110 -20 -65 -1 41 18 148 124
187 185 80 125 104 213 106 382 1 95 -5 130 -39 229 -30 85 -49 118 -110 188
l-56 63 35 -7 c19 -4 56 -16 83 -27z m-164 -177 c125 -89 71 -281 -79 -281
-85 0 -144 62 -145 151 0 120 131 196 224 130z"/>
<path stroke='4'  d="M4804 4416 c-19 -8 -38 -28 -48 -51 -16 -32 -17 -44 -7 -77 24 -79
111 -148 186 -148 73 0 119 86 83 153 -25 48 -73 98 -113 117 -48 23 -59 24
-101 6z"/>
<path stroke='4'  d="M5285 4416 c-42 -18 -112 -100 -126 -146 -9 -30 -8 -43 5 -72 42 -89
168 -71 245 34 52 70 39 148 -29 183 -35 18 -56 18 -95 1z"/>
<path stroke='4'  d="M4023 4085 c-61 -26 -90 -110 -63 -181 18 -45 141 -163 241 -230 159
-106 328 -175 534 -217 96 -19 141 -22 360 -22 226 0 260 2 355 23 223 50 371
111 529 216 100 67 223 185 241 230 36 95 -27 196 -121 196 -33 0 -102 -44
-134 -85 -64 -85 -267 -208 -420 -255 -246 -75 -608 -80 -860 -12 -201 55
-386 161 -480 276 -34 42 -95 76 -133 76 -9 -1 -32 -7 -49 -15z"/>
</g>
</svg>
)
}

export default OraculoSvg
